import Image from "next/image";
import React, { useRef, useState } from "react";
import { useGlobalContext } from "../../context/globalContext";
import useClickOutside from "@/hooks/useClickOutside";
import dynamic from "next/dynamic";

const FavoriteList = dynamic(() => import("./FavoriteList"), {
  ssr: false,
});

const FavoritesButton = () => {
  const { favorites } = useGlobalContext();
  const [showFavorites, setShowFavorites] = useState(false);

  const refOne = useRef(null);
  const refTwo = useRef(null);

  const handleClickOutside = () => {
    setShowFavorites(false);
  };

  useClickOutside([refOne, refTwo], handleClickOutside);
  return (
    <>
      <button
        ref={refOne}
        type="button"
        onClick={() => setShowFavorites(!showFavorites)}
        className="flex items-center gap-2 text-xs font-medium leading-normal bg-transparent text-themeTopbarColor"
      >
        <div className="flex items-center justify-center w-8 h-8 bg-[#E8ECF4] rounded-full sm:w-9 sm:h-9">
          {favorites?.length > 0 ? (
            <Image
              src="/icons/activeHeart.svg"
              alt="heart"
              width={14}
              height={14}
            />
          ) : (
            <Image src="/icons/heart.svg" alt="heart" width={16} height={16} />
          )}
        </div>
        <span className="hidden sm:block">Favorilerim</span>
        {favorites?.length > 0 && <span>{favorites?.length}</span>}
      </button>
      <FavoriteList
        favorites={favorites}
        refTwo={refTwo}
        showFavorites={showFavorites}
        setShowFavorites={setShowFavorites}
      />
    </>
  );
};

export default FavoritesButton;
